"use strict";
var import_vitest = require("vitest");
var import_toServerOutputPath = require("./toServerOutputPath");
(0, import_vitest.describe)("toServerOutputPath", function() {
  (0, import_vitest.it)("prepends ${outDir}/server/ to bare filenames from Vite output", function() {
    (0, import_vitest.expect)((0, import_toServerOutputPath.toServerOutputPath)("assets/loader-abc.js", "dist")).toBe("dist/server/assets/loader-abc.js");
  });
  (0, import_vitest.it)("prepends ${outDir}/server/ to project-relative paths from the route tree", function() {
    (0, import_vitest.expect)((0, import_toServerOutputPath.toServerOutputPath)("./pages/index.tsx", "dist")).toBe("dist/server/pages/index.tsx");
  });
  (0, import_vitest.it)("returns input unchanged when it is already rooted under ${outDir}/server/", function() {
    (0, import_vitest.expect)((0, import_toServerOutputPath.toServerOutputPath)("dist/server/assets/loader-abc.js", "dist")).toBe("dist/server/assets/loader-abc.js");
  });
  (0, import_vitest.it)("treats backslashes as separators on every platform (the Windows path-doubling case)", function() {
    (0, import_vitest.expect)((0, import_toServerOutputPath.toServerOutputPath)("dist\\server\\assets\\loader-abc.js", "dist")).toBe("dist/server/assets/loader-abc.js");
  });
  (0, import_vitest.it)("is idempotent: feeding the output back in returns the same value", function() {
    var first = (0, import_toServerOutputPath.toServerOutputPath)("assets/loader-abc.js", "dist");
    var second = (0, import_toServerOutputPath.toServerOutputPath)(first, "dist");
    (0, import_vitest.expect)(second).toBe(first);
  });
  (0, import_vitest.it)("honors a custom outDir", function() {
    (0, import_vitest.expect)((0, import_toServerOutputPath.toServerOutputPath)("assets/loader.js", "build")).toBe("build/server/assets/loader.js");
  });
  (0, import_vitest.it)("does not false-positive on inputs that contain ${outDir}/server as a substring but are not rooted under it", function() {
    (0, import_vitest.expect)((0, import_toServerOutputPath.toServerOutputPath)("foo/dist/server/bar.js", "dist")).toBe("dist/server/foo/dist/server/bar.js");
  });
});
//# sourceMappingURL=toServerOutputPath.test.js.map
